
import FirstHeader from '../firstheader/firstheader'


import './notfoundpage.css'

const NotFoundPage = () => {
    return (
        <>
            <FirstHeader />
            <div className="notfoundpage">
                <div className="notfoundpage-container">
                    <div className="notfoundpage-box">NOT FOUND</div>
                </div>
            </div>
        </>

    );
}


export default NotFoundPage;